import { updateTicker } from '@/mocks/home';

export default function UpdateStrip() {
  const items = [...updateTicker, ...updateTicker];

  return (
    <div className="w-full bg-foreground-950 text-background-50">
      <div className="mx-auto flex h-9 w-full items-center gap-3 px-4 md:px-8">
        <span className="flex shrink-0 items-center gap-1.5 text-xs font-medium text-primary-300">
          <span className="relative flex h-2 w-2 items-center justify-center">
            <span className="absolute inline-flex h-2 w-2 animate-softPulse rounded-full bg-primary-400" />
            <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-primary-400" />
          </span>
          实时追踪
        </span>
        <span className="h-4 w-px shrink-0 bg-background-50/20" />
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap">
            {items.map((item, index) => (
              <span
                key={`${item}-${index}`}
                className="flex items-center gap-2 text-xs text-background-200"
              >
                <i className="ri-flashlight-fill text-primary-400" />
                {item}
              </span>
            ))}
          </div>
        </div>
        <span className="hidden shrink-0 items-center gap-1.5 text-xs text-background-300 lg:flex">
          <i className="ri-refresh-line" />
          最后更新 2026-09-10
        </span>
      </div>
    </div>
  );
}